import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import Datatable from "../../Constants/Datatable";
import { PENCIL } from "../../Constants/SrcImages";
import { COLUMNS_CYCLES } from "../../Constants/DatatableColumns";
import { Row, Col, Container, Button, Label } from "reactstrap";
import { AdminHandleCycles } from "./../../Constants/Modal";
import { getCycles, postCyles, putCycles } from "../../Constants/Services";
import { ICycles } from "./../../Constants/Interfaces";
import {validateTokenStorage} from './../../Constants/Util';

interface ICycleState {
  datacycle: ICycles[];
  formCycle: ICycles;
  isOpenModalEditCycle: boolean;
  isOpenModalAddCycle: boolean;
  msg_error:string;
}

class Cycles extends Component<RouteComponentProps<{}>, ICycleState> {
  constructor(props: any) {
    super(props);
    this.state = {
      datacycle: [],
      formCycle: {
        cy_id: "",
        cy_desc: "",
      },
      isOpenModalEditCycle: false,
      isOpenModalAddCycle: false,
      msg_error:""
    };

    this.fetchCycle = this.fetchCycle.bind(this);
    this.handlerPutCycle = this.handlerPutCycle.bind(this);
    this.onChangeCycle = this.onChangeCycle.bind(this);
    this.handlerPostCycle = this.handlerPostCycle.bind(this);
    this.handleModalEditCycle = this.handleModalEditCycle.bind(this);
    this.handleModalAddCycle = this.handleModalAddCycle.bind(this);
  }

  async fetchCycle() {
    const response = await getCycles();
    this.setState({
      datacycle: response,
    });
  }

  componentDidMount() {
    if(validateTokenStorage()){
      this.context.quitToken();
    }
    this.fetchCycle();
  }

  handlerPostCycle() {
    const props = this.state.formCycle;
    if(props.cy_desc.length>0){
      const body = {
        cy_id: props.cy_id,
        cy_desc: props.cy_desc,
      };
  
      postCyles(body);
      this.setState({ isOpenModalAddCycle: false,msg_error:"" });
  
      setTimeout(() => {
        this.fetchCycle();
      }, 1000);
    }
    else{
      this.setState({ msg_error: "Campos vacios" });
    }
  }

  handlerPutCycle() {
    const props = this.state.formCycle;
    if(props.cy_desc.length>0 && props.cy_id.length>0){
      const body = {
        cy_id: props.cy_id,
        cy_desc: props.cy_desc,
      };
  
      putCycles(body);
      this.setState({ isOpenModalEditCycle: false,msg_error:"" });
  
      setTimeout(() => {
        this.fetchCycle();
      }, 1000);
    }
    else{
      this.setState({ msg_error: "Campos vacios" });
    }
  }

  onChangeCycle(e: any) {
    this.setState({
      formCycle: {
        ...this.state.formCycle,
        [e.target.name]: e.target.value,
      },
      msg_error:""
    });
  }

  handleModalEditCycle(row: ICycles) {
    this.setState((prevState) => ({
      isOpenModalEditCycle: !prevState.isOpenModalEditCycle,
      formCycle: row,
      msg_error:""
    }));
  }

  handleModalAddCycle() {
    this.setState((prevState) => ({
      isOpenModalAddCycle: !prevState.isOpenModalAddCycle,
      formCycle: {
        cy_id: "",
        cy_desc: "",
      },
      msg_error:""
    }));
  }

  colummCycle = (cell: any, row: ICycles) => (
    <React.Fragment>
      <Row>
        <Col xs={12} className ="d-flex">
        <Label className="txt-underline" onClick={() => this.handleModalEditCycle(row)}>
        {row.cy_id}
      </Label>
      <img className="img-status img-search" onClick={() => this.handleModalEditCycle(row)} src={PENCIL} alt="" />
        </Col>
      </Row>
    </React.Fragment>
  );

  render() {
    const props = this.state;
    return (
      <React.Fragment>
        {props.isOpenModalEditCycle && (
          <AdminHandleCycles
            title="Editar ciclo"
            dataFCycle={props.formCycle}
            isOpen={props.isOpenModalEditCycle}
            toggle={this.handleModalEditCycle}
            toggleSave={this.handlerPutCycle}
            onChange={this.onChangeCycle}
            msg_error={props.msg_error}
          />
        )}
        {props.isOpenModalAddCycle && (
          <AdminHandleCycles
            title="Agregar ciclo"
            dataFCycle={props.formCycle}
            isOpen={props.isOpenModalAddCycle}
            toggle={this.handleModalAddCycle}
            toggleSave={this.handlerPostCycle}
            onChange={this.onChangeCycle}
            msg_error={props.msg_error}
          />
        )}
        <Container className="mt-4">
          <Row>
            <Col sm={12}>
              <Row>
                <Col sm={12} className="text-center">
                  <h3>Ciclos</h3>
                </Col>
                <Col sm={12} className="text-right">
                  <Button color="success" className="mr-2" onClick={() => this.handleModalAddCycle()}>
                    Agregar nuevo
                  </Button>
                </Col>
                <Col sm={12}>
                  <Datatable data={props.datacycle} columns={COLUMNS_CYCLES(this.colummCycle)} keyProp="cy_id" exportD={false} searchs={false} selectRows={false} optionSelectRow={null} />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default Cycles;
